var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import MuiCardHeader from '@mui/material/CardHeader';
import { defaultCardSize, useCardContext } from '../card-context';
import { styled } from '../../styled';
import { Text } from '../../text';
import { cardHeaderClasses, cardHeaderComponentName, getCardHeaderUtilityClass, } from './card-header-classes';
import clsx from '../../utils/clsx';
import { useMergedClasses } from '../../styles/classes';
var Root = styled(MuiCardHeader, { name: cardHeaderComponentName })(function (_a) {
    var _b;
    var ownerState = _a.ownerState;
    return (_b = {},
        _b[".".concat(cardHeaderClasses.avatar)] = {
            paddingTop: ownerState.size === 'large' || ownerState.size === 'xlarge' ? 5 : ownerState.size === 'small' ? 2 : 4,
        },
        _b);
});
var Title = styled(Text, { name: cardHeaderComponentName, slot: 'Title' })(function (_a) {
    var theme = _a.theme, ownerState = _a.ownerState;
    return ({
        marginBottom: ownerState.size === 'small' ? theme.spacing(0.25) : theme.spacing(0.5),
        '&:last-child': {
            marginBottom: 0,
        },
    });
});
var titleVariantMap = {
    small: 'subtitle2',
    medium: 'subtitle2',
    large: 'subtitle1',
    xlarge: 'subtitle1',
};
export var CardHeader = React.forwardRef(function (props, ref) {
    var sizeContext = useCardContext().size;
    var sizeProp = props.size, _a = props.titleTypographyProps, titleTypographyProps = _a === void 0 ? {} : _a, _b = props.subheaderTypographyProps, subheaderTypographyProps = _b === void 0 ? {} : _b, title = props.title, subheader = props.subheader, propClasses = props.classes, cardProps = __rest(props, ["size", "titleTypographyProps", "subheaderTypographyProps", "title", "subheader", "classes"]);
    var classes = useMergedClasses(cardHeaderClasses, getCardHeaderUtilityClass, propClasses);
    var size = sizeProp || sizeContext || defaultCardSize;
    var titleVariant = titleVariantMap[size];
    return (React.createElement(Root, __assign({ ref: ref, ownerState: { size: size }, classes: {
            action: classes.action,
            avatar: classes.avatar,
            content: classes.content,
        }, title: React.createElement(Title, __assign({ variant: titleVariant, color: "textPrimary" }, { component: 'h2' }, { display: "block" }, titleTypographyProps, { className: clsx(classes.title, titleTypographyProps.className), ownerState: { size: size } }), title), subheader: subheader ? (React.createElement(Text, __assign({ variant: "body2", color: "textSecondary", component: "p" }, subheaderTypographyProps, { className: clsx(classes.subheader, subheaderTypographyProps.className) }), subheader)) : null }, cardProps, { disableTypography: true })));
});
